/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CaseNoteTemplateResponse,
  CreateCaseNoteTemplateRequest,
  ProblemDetails,
  ResolveCaseNoteTemplateRequest,
  ResolvedCaseNoteTemplateResponse,
  UpdateCaseNoteTemplateRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    CaseNoteTemplateResponseFromJSON,
    CaseNoteTemplateResponseToJSON,
    CreateCaseNoteTemplateRequestFromJSON,
    CreateCaseNoteTemplateRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ResolveCaseNoteTemplateRequestFromJSON,
    ResolveCaseNoteTemplateRequestToJSON,
    ResolvedCaseNoteTemplateResponseFromJSON,
    ResolvedCaseNoteTemplateResponseToJSON,
    UpdateCaseNoteTemplateRequestFromJSON,
    UpdateCaseNoteTemplateRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateCaseNoteTemplateOperationRequest {
    createCaseNoteTemplateRequest: CreateCaseNoteTemplateRequest;
}

export interface DeleteCaseNoteTemplateRequest {
    id: string;
}

export interface ResolveCaseNoteTemplateOperationRequest {
    id: string;
    resolveCaseNoteTemplateRequest: ResolveCaseNoteTemplateRequest;
}

export interface UpdateCaseNoteTemplateOperationRequest {
    id: string;
    updateCaseNoteTemplateRequest: UpdateCaseNoteTemplateRequest;
}

/**
 * CaseNoteTemplatesApi - interface
 * 
 * @export
 * @interface CaseNoteTemplatesApiInterface
 */
export interface CaseNoteTemplatesApiInterface {
    /**
     * 
     * @param {CreateCaseNoteTemplateRequest} createCaseNoteTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNoteTemplatesApiInterface
     */
    createCaseNoteTemplateRaw(requestParameters: CreateCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteTemplateResponse>>;

    /**
     */
    createCaseNoteTemplate(requestParameters: CreateCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteTemplateResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNoteTemplatesApiInterface
     */
    deleteCaseNoteTemplateRaw(requestParameters: DeleteCaseNoteTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteCaseNoteTemplate(requestParameters: DeleteCaseNoteTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNoteTemplatesApiInterface
     */
    getAllCaseNoteTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CaseNoteTemplateResponse>>>;

    /**
     */
    getAllCaseNoteTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CaseNoteTemplateResponse>>;

    /**
     * 
     * @param {string} id 
     * @param {ResolveCaseNoteTemplateRequest} resolveCaseNoteTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNoteTemplatesApiInterface
     */
    resolveCaseNoteTemplateRaw(requestParameters: ResolveCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResolvedCaseNoteTemplateResponse>>;

    /**
     */
    resolveCaseNoteTemplate(requestParameters: ResolveCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResolvedCaseNoteTemplateResponse>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateCaseNoteTemplateRequest} updateCaseNoteTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNoteTemplatesApiInterface
     */
    updateCaseNoteTemplateRaw(requestParameters: UpdateCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteTemplateResponse>>;

    /**
     */
    updateCaseNoteTemplate(requestParameters: UpdateCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteTemplateResponse>;

}

/**
 * 
 */
export class CaseNoteTemplatesApi extends runtime.BaseAPI implements CaseNoteTemplatesApiInterface {

    /**
     */
    async createCaseNoteTemplateRaw(requestParameters: CreateCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteTemplateResponse>> {
        if (requestParameters['createCaseNoteTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'createCaseNoteTemplateRequest',
                'Required parameter "createCaseNoteTemplateRequest" was null or undefined when calling createCaseNoteTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/case-note-templates`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCaseNoteTemplateRequestToJSON(requestParameters['createCaseNoteTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseNoteTemplateResponseFromJSON(jsonValue));
    }

    /**
     */
    async createCaseNoteTemplate(requestParameters: CreateCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteTemplateResponse> {
        const response = await this.createCaseNoteTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteCaseNoteTemplateRaw(requestParameters: DeleteCaseNoteTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCaseNoteTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/case-note-templates/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCaseNoteTemplate(requestParameters: DeleteCaseNoteTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCaseNoteTemplateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllCaseNoteTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CaseNoteTemplateResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/case-note-templates`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CaseNoteTemplateResponseFromJSON));
    }

    /**
     */
    async getAllCaseNoteTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CaseNoteTemplateResponse>> {
        const response = await this.getAllCaseNoteTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async resolveCaseNoteTemplateRaw(requestParameters: ResolveCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResolvedCaseNoteTemplateResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resolveCaseNoteTemplate().'
            );
        }

        if (requestParameters['resolveCaseNoteTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'resolveCaseNoteTemplateRequest',
                'Required parameter "resolveCaseNoteTemplateRequest" was null or undefined when calling resolveCaseNoteTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/case-note-templates/{id}/resolve`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResolveCaseNoteTemplateRequestToJSON(requestParameters['resolveCaseNoteTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResolvedCaseNoteTemplateResponseFromJSON(jsonValue));
    }

    /**
     */
    async resolveCaseNoteTemplate(requestParameters: ResolveCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResolvedCaseNoteTemplateResponse> {
        const response = await this.resolveCaseNoteTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCaseNoteTemplateRaw(requestParameters: UpdateCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteTemplateResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCaseNoteTemplate().'
            );
        }

        if (requestParameters['updateCaseNoteTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCaseNoteTemplateRequest',
                'Required parameter "updateCaseNoteTemplateRequest" was null or undefined when calling updateCaseNoteTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/case-note-templates/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCaseNoteTemplateRequestToJSON(requestParameters['updateCaseNoteTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseNoteTemplateResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateCaseNoteTemplate(requestParameters: UpdateCaseNoteTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteTemplateResponse> {
        const response = await this.updateCaseNoteTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
